import type { Location, LocationState } from 'history';
import { createContext, useContext, useEffect, useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useLocation as useLocationOriginal } from 'react-router';
import type { LocationStateWithBackground } from '../../routing/history';
import history from '../../routing/history';

const backgroundRouteContext = createContext(true);

export const BackgroundRouteContextProvider = backgroundRouteContext.Provider;

const useLocation = <S = LocationState>() => {
    const location = useLocationOriginal();
    const isBackground = useContext(backgroundRouteContext);
    return getBackgroundLocation(location as Location<LocationStateWithBackground>, isBackground) as Location<S>;
};

export const useModalRouteDepth = () => {
    const location = useLocationOriginal<LocationStateWithBackground>();
    return location.state?.modalRouteDepth;
};

/**
 * @deprecated Only use if you must, e.g. when react is wrapped in angular
 */
export const useLocationOutsideRouterContext = <S = LocationState>(isBackground = false) => {
    if (!history) {
        throw new Error('useLocation must not be used outside the SPA');
    }

    const [location, setLocation] = useState(history.location);

    useEffect(() => {
        if (history) {
            return history.listen(newLocation => {
                setLocation(newLocation);
            });
        }
    }, []);

    return getBackgroundLocation(location as Location<LocationStateWithBackground>, isBackground) as Location<S>;
};

const getBackgroundLocation = (location: Location<LocationStateWithBackground>, isBackground: boolean) => {
    const backgroundLocation = location.state?.backgroundLocation;
    return (isBackground && backgroundLocation) || location;
};

export default useLocation;
